<template>
    <v-col cols="12" class="dashboard-consumer mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                        style="position: relative"
                >
                    <v-menu  offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    v-on="on"
                                    absolute
                                    dark
                                    fab
                                    right
                                    color="#0172C0"
                                    class="shadow-1"
                            >
                                <v-icon>mdi-flash</v-icon>
                            </v-btn>
                        </template>
                        <v-card
                            color="#FFF"
                            width="300px"
                            class="pa-5 rounded-lg shadow-1"
                        >
                            <h4>Servicios Neocity</h4>
                            <v-row >
                                <v-col cols="3" v-for="iconCArdMenu in 20">
                                    <v-btn
                                            dark
                                            fab
                                            small
                                            color="grey"
                                    >
                                        <v-icon>mdi-flash-circle</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-menu>
                    <h2 class="mt-4 font-weight-medium text-center font-family-1 font-size-30">Escritorio <span class="blue--text">de Administración</span></h2>
                    <v-row>
                        <v-col md="12" lg="8" xl="6" class="pr-0">
                            <v-card
                                    class="pa-4 pr-0 elevation-0"
                                    tile
                                    height="100%"
                            >
                                <h4 class="font-weight-medium font-family-1 font-size-18 pb-4">Perfil <span class="blue--text">Consumidor</span></h4>

                              
                                    <v-row>
                                        <v-col cols="5" class="pr-0">
                                         <v-card
                                                    class="card-profile-bienvenida rounded-lg rounded-br-0 rounded-tr-0 shadow-1"
                                                    color="#0172C0"
                                                    height="88px"
                                            >
                                            <v-row>
                                                <v-col class="pl-8 text-center " cols="4">
                                                    <v-avatar size="50px" class="mt-2">
                                                        <img
                                                                src="@/assets/images/perfil.png"
                                                                alt="John"
                                                        >
                                                    </v-avatar>
                                                </v-col>
                                                <v-col  cols="8" class="my-auto pl-0">
                                                    <h4 class="white--text"> <span class="font-weight-light">Hola,</span> Nombre Apellido</h4>
                                                </v-col>
                                            </v-row>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="7" class="pl-0">
                                            <v-card
                                                    class="card-profile-bienvenida-datos px-5 py-3 rounded-lg rounded-bl-0 rounded-tl-0 shadow-1"
                                                    color="#FFF"
                                                    height="88px"

                                            >
                                                <v-row>
                                                    <v-col cols="2" class="pa-1">
                                                        Empresa:
                                                    </v-col>
                                                    <v-col cols="10" class="pa-1">

                                                        <v-select
                                                                style="height:25px"
                                                                :items="['NEOCITY ENERGÍA']"
                                                                value="NEOCITY ENERGÍA"
                                                                dense
                                                        ></v-select>

                                                    </v-col>
                                                </v-row>

                                                <v-row>
                                                    <v-col cols="2" class="pa-1">
                                                        Rut:
                                                    </v-col>
                                                    <v-col cols="10" class="pa-1">
                                                        <h4 class="blue--text">11.111.111-1</h4>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-col>

                                    </v-row>
                                
                                <v-row>
                                    <v-col cols="3">
                                        <h4 class="font-weight-bold font-size-16">Mi empresa en números</h4>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-select
                                                class="select-color-blue-min"
                                                :items="['ABR / 19 - Mar / 20']"
                                                value="ABR / 19 - Mar / 20"
                                                dense
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-col cols="12" class="px-0 pt-0">
                            
                                <v-carousel height="200px" hide-delimiters>
                                            <v-carousel-item
                                            v-for="(item,i) in 2"
                                            :key="i"
                                            >
                                                <v-row>
                                                    <v-col>
                                                        <v-card color="#f9f9f9" class="elevation-1 rounded-lg pa-3" height="180px">
                                                            <h3 class="grey--text">Grafico {{1+(i)}}</h3>
                                                        </v-card>
                                                    </v-col>

                                                    <v-col>
                                                    
                                                        <v-card color="#f9f9f9" class="elevation-1 rounded-lg pa-3" height="180px">
                                                            <h3 class="grey--text">Grafico {{2+(i+1)}}</h3>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                            </v-carousel-item>
                                        </v-carousel>
                       

                                </v-col>
                                
                                <v-row>
                                    <v-col sm="12" md="12"  lg="4">
                                        <v-card height="100px" class="card-numeros shadow-1 rounded-lg pa-3 mr-8">
                                            <v-row class="blue--text">
                                                <v-col cols="10" class="mx-auto">
                                                    <h2>150 <span>GWH-año</span></h2>
                                                    <p>Energía Anual</p>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                    <v-col sm="12" md="12"  lg="4">
                                        <v-card height="100px"  dark color="#0172c0" class="card-numeros shadow-1 rounded-lg pa-3 mr-8">
                                            <v-row>
                                                <v-col cols="10" class="mx-auto">
                                                    <h2>150  <span>KW-mes</span></h2>
                                                    <p>Potencia Máxima</p>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                    <v-col sm="12" md="12" lg="4">
                                        <v-card height="100px" class="card-numeros shadow-1 rounded-lg pa-3">
                                            <v-row class="blue--text">
                                                <v-col cols="10" class="mx-auto">
                                                    <h2>60 <span>KW-mes</span></h2>
                                                    <p>Potencia Máxima</p>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                </v-row>

                                <v-card class="rounded-lg elevation-0 pa-3" color="#F6F6F6" >
                                    <v-row>
                                        <v-col cols="6" class="calculadora">
                                            <v-row>
                                                <v-col class="pt-0">
                                                    <h4 class="font-size-16">Calculadora de consumo</h4>
                                                </v-col>
                                               
                                            </v-row>

                                            <p class="font-italic font-size-12"> ingresa tus números actuales para ver tus resultados Neocity </p>
                                            <v-row>
                                                <v-col class="py-1" cols="3"><p>Tipo de Moneda</p></v-col>
                                                <v-col class="py-1" cols="9">
                                                    <v-select
                                                            class="select-color-blue-big"
                                                            :items="['USD']"
                                                            value="USD"
                                                            dense
                                                    ></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="py-1" cols="3"><p>Energía</p></v-col>
                                                <v-col class="py-1" cols="9">
                                                    <v-text-field
                                                            class="input-color-blue-big"
                                                            placeholder="0 USD / MWh"
                                                            value="0 USD / MWh"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="py-1" cols="3" ><p>Potencia</p></v-col>
                                                <v-col class="py-1" cols="9" >
                                                    <v-text-field
                                                            class="input-color-blue-big"
                                                            placeholder="0 USD / MWh"
                                                            value="0 USD / MWh"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="py-3" cols="3" ></v-col>
                                                <v-col class="py-3" cols="4" >
                                                    <h5>Pago Actual</h5>
                                                </v-col>
                                                <v-col class="py-3" cols="5" >
                                                    <h5>Promedio neocity</h5>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="py-1" cols="3" >
                                                    <p>Energía</p>
                                                </v-col>
                                                <v-col class="py-1" cols="4" >
                                                    <v-text-field
                                                            class="input-color-blue-medium"
                                                            placeholder="$100.000"
                                                            value="$100.000"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col class="py-1" cols="5" >
                                                     <v-text-field
                                                            class="input-color-orange-medium"
                                                            placeholder="$100.000"
                                                            value="$100.000"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="py-1" cols="3" >
                                                   <p>Potencia</p>
                                                </v-col>
                                                <v-col class="py-1" cols="4" >
                                                     <v-text-field
                                                            class="input-color-blue-medium"
                                                            placeholder="$100.000"
                                                            value="$100.000"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col class="py-1" cols="5" >
                                                     <v-text-field
                                                            class="input-color-orange-medium"
                                                            placeholder="$100.000"
                                                            value="$100.000"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="py-1" cols="3" >
                                                    <p>Transmisión</p>
                                                </v-col>
                                                <v-col class="py-1" cols="4" >
                                                     <v-text-field
                                                            class="input-color-blue-medium"
                                                            placeholder="$100.000"
                                                            value="$100.000"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col class="py-1" cols="5" >
                                                     <v-text-field
                                                            class="input-color-orange-medium"
                                                            placeholder="$100.000"
                                                            value="$100.000"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="py-1" cols="3" >
                                                    <p>Distribución</p>
                                                </v-col>
                                                <v-col class="py-1" cols="4" >
                                                     <v-text-field
                                                            class="input-color-blue-medium"
                                                            placeholder="$100.000"
                                                            value="$100.000"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col class="py-1" cols="5" >
                                                     <v-text-field
                                                            class="input-color-orange-medium"
                                                            placeholder="$100.000"
                                                            value="$100.000"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="py-1" cols="3" >
                                                    <p>TOTAL</p>
                                                </v-col>
                                                <v-col class="py-1" cols="4" >
                                                     <v-text-field
                                                            class="input-color-blue-medium"
                                                            placeholder="$100.000"
                                                            value="$100.000"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col class="py-1" cols="5" >
                                                     <v-text-field
                                                            class="input-color-orange-medium"
                                                            placeholder="$100.000"
                                                            value="$100.000"
                                                            dense
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="py-1" cols="3"><p>Pago Actual</p></v-col>
                                                <v-col class="py-1" cols="9"><v-progress-linear
                                                        background-color="primary darken-1"
                                                        color="primary"
                                                        value="15"
                                                        height="15"
                                                ></v-progress-linear></v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="py-1" cols="3"><p>Promedio Neocity</p></v-col>
                                                <v-col class="py-1" cols="9"><v-progress-linear
                                                        background-color="primary darken-1"
                                                        color="primary"
                                                        value="50"
                                                        height="15"
                                                ></v-progress-linear></v-col>
                                            </v-row>  
                                            <v-row>
                                            <v-col class="py-1" cols="3"></v-col>
                                            <v-col class="py-1" cols="9">
                                                <v-btn
                                                        color="primary"
                                                        raised
                                                        dark
                                                        dense
                                                        class="pa-4"
                                                >
                                                    calcular
                                                </v-btn>
                                            </v-col>

                                               
                                            </v-row>
                                            

                                        </v-col>
                                        <v-col cols="6">
                                            <h4 class="font-size-16">Resultados</h4>
                                            <v-card height="190" color="#79B216" dark class="card-green shadow-1 rounded-lg pa-3 mt-5">
                                                <v-col cols="11" class="mx-auto py-0">
                                                    <v-row>
                                                        <v-col class="pl-0" cols="2">
                                                            <h2>0% </h2>
                                                        </v-col>
                                                        <v-col cols="10">
                                                            <h3>Diferencia</h3>
                                                            <p class="mb-0">Comparando con tu plan actual</p>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col class="pl-0" cols="2">
                                                            <h2>23</h2>
                                                        </v-col>
                                                        <v-col cols="10">
                                                            <h3>Ofertas de suministro</h3>
                                                            <p class="mb-2">Coincidencias con tus números</p>
                                                            
                                                            <p class="mb-0"><b>10</b> comienzan contrato en Julio 2020</p>
                                                            <p class="mb-0"><b>4</b> comienzan contrato en Julio 2021</p>
                                                            <p class="mb-0"><b>9</b> comienzan contrato en Julio 202</p>

                                                        </v-col>

                                                    </v-row>
                                                </v-col>
                                                
                                            </v-card>
                                            <v-row>
                                                <v-col>
                                                     <v-card height="100px" class="card-numeros shadow-1 rounded-lg pa-3">
                                                        <v-row class="blue--text">
                                                            <v-col cols="10" class="mx-auto">
                                                                <h2>50 <span>USD/MWh</span></h2>
                                                                <p>Precio prom. energía</p>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-col>
                                                <v-col>
                                                    <v-card height="100px" class="card-numeros shadow-1 rounded-lg pa-3">
                                                            <v-row class="blue--text">
                                                                <v-col cols="10" class="mx-auto">
                                                                    <h2>150 <span>USD/MWh</span></h2>
                                                                    <p>Precio prom. potencia</p>
                                                                </v-col>
                                                            </v-row>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-card height="100px" class="card-numeros shadow-1 rounded-lg pa-3">
                                                            <v-row class="blue--text">
                                                                <v-col cols="10" class="mx-auto">
                                                                    <h4 class="font-size-18">2500 USD</h4>
                                                                    <p class="mt-3">Tu facturación</p>
                                                                </v-col>
                                                            </v-row>
                                                    </v-card>
                                                </v-col>
                                                <v-col>
                                                     <v-card height="100px" class="card-numeros shadow-1 rounded-lg pa-3">
                                                            <v-row class="blue--text">
                                                                <v-col cols="10" class="mx-auto">
                                                                    <h4 class="font-size-18">28 días</h4>
                                                                    <p class="mt-3">Tiempo estimado de cierre</p>
                                                                </v-col>
                                                            </v-row>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>

                                </v-card>

                            </v-card>
                        </v-col>
                        <v-col md="12" lg="4" xl="6">
                            <v-card
                                    class="pa-4 pl-0 elevation-0"
                                    tile
                                    height="100%"
                            >
                                <v-row>
                                    <!-- timeline -->
                                    <v-col  xl="7" lg="12" class="pr-12 pl-0 pt-0">
                                        <template>
                                            <v-timeline dense  class="timeline-status pt-0">
                                                <v-timeline-item
                                                        color="green"
                                                        small
                                                        fill-dot
                                                        class="pb-0"
                                                        
                                                >
                                                    <v-row >
                                                        <v-col>
                                                            <strong class="font-size-20">Estado</strong>
                                                        </v-col>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="green"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-check</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" class="shadow-1" >
                                                            <v-card-text>
                                                                <strong>
                                                                    Mi perfil de usuario
                                                                </strong>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" class="rounded-lg shadow-1" >
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col cols="10">
                                                                        <strong>Mis Empresas</strong>
                                                                        <div class="caption">
                                                                            <a @click="dialog.createCompany = true" href="#">Agregar [+]</a>
                                                                            <span class="red--text">
                                                                                No hay empresas
                                                                            </span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col cols="2">
                                                                        <h1 class="blue--text font-size-30">0</h1>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" class="rounded-lg shadow-1" >
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col cols="10">
                                                                        <strong>Mis Puntos de Retiro</strong>
                                                                        <div class="caption">
                                                                            <a @click="dialog.withdrawalPoint = true" href="#">Agregar [+]</a>
                                                                            <span class="red--text">
                                                                                No hay puntos de retiro
                                                                            </span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col cols="2">
                                                                        <h1 class="blue--text font-size-30">0</h1>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" @click="$refs.documentLoaded.dialog.show = true" class="rounded-lg shadow-1" >
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col cols="12">
                                                                        <strong>Documentos Necesarios</strong>
                                                                        <div class="caption">
                                                                            <span class="red--text">
                                                                                No hay documentos cargados
                                                                            </span>
                                                                        </div>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%"  @click="dialog.updatePlan = true" color="#C6C6C6" dark class="" elevation="2">
                                                            <v-card-text>
                                                                <strong>
                                                                    Aun no tenemos ofertas para ti
                                                                </strong>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" class="rounded-lg focus-blue-1" >
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col cols="10">
                                                                        <strong>Seguimiento de Solicitudes</strong>
                                                                        <div class="caption">
                                                                            <span class="red--text">
                                                                                No hay solicitudes
                                                                            </span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col cols="2">
                                                                        <h1 class="blue--text font-size-30">0</h1>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" class="rounded-lg shadow-1" >
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col cols="10">
                                                                        <strong>Contratos Activos</strong>
                                                                        <div class="caption">
                                                                            <span class="red--text">
                                                                                Sin registros
                                                                            </span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col cols="2">
                                                                        <h1 class="blue--text font-size-30">0</h1>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="green"
                                                        small
                                                        fill-dot
                                                >

                                                </v-timeline-item>

                                            </v-timeline>
                                        </template>
                                    </v-col>
                                    <v-col  xl="5" lg="12" class="pl-8">
                                        <h4 class="font-weight-medium pb-4 font-size-20"> Historial de actividad</h4>
                                        <v-card class="card-novedades pb-12 rounded-lg shadow-1" >
                                            <v-card-text>
                                                <p class="pl-4 font-weight-bold font-size-16 dark-grey--text mb-0">Novedades</p>
                                                <v-list-item v-for="li in 4" two-line>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle class="font-italic">14 - 07 -2020 / 10:20</v-list-item-subtitle>
                                                        <v-list-item-title>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras tincidunt mauris eu fringilla aliquam. </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-card-text>
                                        </v-card>

                                        <v-card class="card-mi-plan mt-6 pb-12 rounded-lg shadow-1" >
                                            <v-card-text>
                                                <v-list-item two-line>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-weight-bold">Mis Transacciones </v-list-item-title>
                                                        <v-list-item-subtitle class="red--text">Sin registros</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item two-line>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-weight-bold">Mis Estadisticas </v-list-item-title>
                                                        <v-list-item-subtitle class="red--text">Sin registros</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item two-line>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-weight-bold">Mis Planes </v-list-item-title>
                                                        <v-list-item-subtitle class="red--text">Sin registros</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>


            </v-col>
        </v-row>

        <v-dialog
                v-model="dialog.createCompany"
                width="724"
        >
            <v-card class="pa-8 elevation-0"
                    tile
                    height="864"
            >
                    <v-card-title class="headline pt-0 mx-auto justify-center">
                        <h2 class="font-weight-regular text-center font-family-1 font-size-30">Agregar una Empresa</h2>
                    </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="4">
                            <v-card
                                    class="pa-4 ma-0 elevation-0 border-1"
                                    tile
                                    height="160px"
                                    width="160px"
                            >
                                <v-img src="@/assets/images/neocity-logo.png"
                                       height="140px"
                                       width="140px"
                                       aspect-ratio="2"
                                       contain>
                                </v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="8" class="pt-12">
                             <v-row class="px-3">
                                <v-col class="pa-0" cols="4">
                                    <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Rut de la Empresa</v-subheader>
                                </v-col>
                                <v-col class="pa-0" cols="8">
                                    <v-text-field
                                            dense
                                            placeholder="00.000.000-0"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="px-3">
                                <v-col class="pa-0" cols="4">
                                    <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Razon Social</v-subheader>
                                </v-col>
                                <v-col class="pa-0" cols="8">
                                    <v-text-field
                                            placeholder="Razon Social Empresa"
                                            dense

                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    
                     <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Región de Retiro (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                          <v-select
                                    :items="['Metropolitana']"
                                    placeholder="Selecciona la región de retiro"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                     <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Comuna de Retiro (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                             <v-select
                                    :items="['Las Condes']"
                                    placeholder="Selecciona la comuna de retiro"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Giro Comercial (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Giro Empresa"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Direccion Comercial (*)
                            </v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Calle #000, Comuna, Region, Pais"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Representante Legal (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Nombre Apellido"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1 " style="height: 27px; ">Correo Electronico (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="info@neocity.cl"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Teléfono</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="+56 2 2222 2222"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-5 px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Sitio Web</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="www.neocity.cl"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-start">
                    <v-btn color="primary"
                       raised
                       dark
                       @click="dialog.createCompany = false"
                       class="pa-6">Agregar Empresa</v-btn>
                </v-card-actions>

            </v-card>

        </v-dialog>

        <v-dialog
                v-model="dialog.withdrawalPoint"
                width="724"
        >
            <v-card class="pa-8 elevation-0"
                    tile
                
            >
                <v-card-title class="headline pt-0 mx-auto justify-center">
                    <h2 class="font-weight-medium text-center font-family-1 font-size-30">Agregar Punto de Retiro</h2>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="4">
                            <v-card
                                    class="pa-4 ma-0 shadow-1 rounded-lg"
                                    tile
                                    height="160px"
                                    width="160px"
                            >
                                <v-img src="@/assets/images/neocity-logo.png"
                                       height="140px"
                                       width="140px"
                                       aspect-ratio="2"
                                       contain>
                                </v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="8" class="pt-12">
                            <p>Neocity Energía</p>
                            <h3>76.222.222-7</h3>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Nombre del punto de retiro</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Nombre del punto"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Potencia</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="220KV"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Energía Anual</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="660KV"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Direccion del Punto de Retiro
                            </v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Calle #000, Comuna, Region, Pais"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Fecha de Inicio Contrato</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="01 - 05 -2020"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1 " style="height: 27px; ">Periodo de contrato</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="1 Año"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-5 px-3 pb-3">
                        <v-col class="pa-0 border-bottom-1" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 " style="height: 27px; ">Bloque</v-subheader>
                        </v-col>
                        <v-col class="pa-0 border-bottom-1" cols="8">
                            <div class="mx-auto d-inline-flex">
                            <v-checkbox dense hide-details value="1">
                                <template v-slot:label>
                                    <v-chip
                                                class="ma-2"
                                                color="#004E85"
                                                label
                                                text-color="white"
                                        >
                                        A
                                    </v-chip>
                                </template>
                            </v-checkbox>
                                
                                <v-checkbox dense hide-details value="1">
                                    <template v-slot:label>
                                        <v-chip
                                            class="ma-2"
                                            color="#FF9A1B"
                                            label
                                            text-color="white"
                                        >
                                            B
                                        </v-chip>
                                    </template>
                                </v-checkbox>
                               
                                <v-checkbox dense hide-details value="1">
                                    <template v-slot:label>
                                        <v-chip
                                            class="ma-2"
                                            color="#0172C0"
                                            label
                                            text-color="white"
                                        >
                                            C
                                        </v-chip>
                                    </template>
                                </v-checkbox>
                               
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="px-3 ">
                        <v-col class="pa-0 border-bottom-1" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 " style="height: 27px; ">Consideraciones</v-subheader>
                        </v-col>
                        <v-col class="pa-0 border-bottom-1" cols="8">
                            <v-textarea
                                    name="input-7-1"
                                    value="Ingrese aquí especificaciones"
                            ></v-textarea>

                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="primary"
                           raised
                           dark
                           @click="dialog.withdrawalPoint = false"
                           class="pa-6">Agregar Punto De Retiro</v-btn>
                </v-card-actions>

            </v-card>

        </v-dialog>

        <v-dialog
                v-model="dialog.updatePlan"
                width="1170"
                
        >
            <v-card class="pa-8 elevation-0"
                    tile
                    height="911"
            >
                <template v-if="!dialog.payment">
                    <v-card-title class="headline pt-0 mx-auto justify-center">
                        <h2 class="font-weight-medium text-center font-family-1 font-size-30">Selecciona tus Servicio Neocity</h2>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="8">
                                <h4 class="my-4">Selecciona tu plan <small class="caption">Selecciona el plan según tus necesidades</small></h4>
                                <v-row>
                                    <v-col cols="3" class="pa-1">
                                        <v-card height="220px" class="shadow-1 text-center rounded-lg px-1 py-5 card-plan">
                                            <h5 class="grey--text" >Hasta</h5>
                                            <h1 class="blue--text">1MW</h1>
                                            <h5 class="blue--text">Energía</h5>
                                            <v-chip class="py-8 rounded-0 chip-label" dark color="blue" label>
                                                <h1>0 <small>uf/año</small></h1>
                                            </v-chip>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="3" class="pa-1">
                                         <v-card height="220px" class="shadow-1 text-center px-1 py-5 rounded-lg card-plan active" >
                                            <h5 class="grey--text" >Hasta</h5>
                                            <h1 class="orange--text">5MW</h1>
                                            <h5 class="orange--text">Energía</h5>
                                            <v-chip class="py-8 rounded-0 chip-label" dark color="orange" label>
                                                <h1>25 <small>uf/año</small></h1>
                                            </v-chip>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="3" class="pa-1">
                                         <v-card height="220px" class="shadow-1 text-center px-1 rounded-lg py-5 card-plan">
                                            <h5 class="grey--text" >Hasta</h5>
                                            <h1 class="green--text">5MW</h1>
                                            <h5 class="green--text">Energía</h5>
                                            <v-chip class="py-8 rounded-0 chip-label" dark color="green" label>
                                                <h1>25 <small>uf/año</small></h1>
                                            </v-chip>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="3" class="pa-1">
                                         <v-card height="220px" class="shadow-1 text-center px-1 rounded-lg py-5 card-plan" disabled>
                                            <h5 class="grey--text" >Hasta</h5>
                                            <h1 class="orange--text">5MW</h1>
                                            <h5 class="orange--text">Energía</h5>
                                            <v-chip class="py-8 rounded-0 chip-label" dark color="orange" label>
                                                <h1>100 <small>uf/año</small></h1>
                                            </v-chip>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <h4 class="my-4">Servicios complementarios <small class="caption">Servicios, descuentos y promociones para optimizar tu plan</small></h4>
                                <v-row>
                                    <v-col cols="3" class="pa-1">
                                        <v-card height="220px" class="shadow-1 text-center rounded-lg px-1 py-5 card-plan active" >
                                            <h1 class="blue--text">25%</h1>
                                            <h5 class="blue--text">descuento</h5>
                                            <h6 class="font-weight-light red--text">Por pago adelantado</h6>
                                            <h4>PAGO DE ENVÍO <br> DE SOLICITUDES</h4>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="3" class="pa-1">
                                         <v-card height="220px" class="shadow-1 text-center rounded-lg px-1 py-5 card-plan" >
                                            <h1 class="blue--text">25%</h1>
                                            <h5 class="blue--text">descuento</h5>
                                             <h6 class="font-weight-light red--text">Por pago adelantado</h6>
                                             <h4>PAGO DE ENVÍO <br> DE SOLICITUDES</h4>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="4">
                                <h4 class="mb-4">Selecciona tu PLan</h4>
                                <div class="my-4 d-flex">
                                    <v-icon color="green"> mdi-check </v-icon>
                                    <span class="ml-3">Despliegue de todas las ofertas disponibles</span>
                                </div>
                                <div class="my-4 d-flex">
                                    <v-icon color="green"> mdi-check </v-icon>
                                    <span class="ml-3">Datos de contacto de los ejecutivos de los administradores</span>
                                </div>
                                <div class="my-4 d-flex">
                                    <v-icon color="green"> mdi-check </v-icon>
                                    <span class="ml-3">Datos estadisticos de los suministros del CEN</span>
                                </div>
                                <div class="my-4 d-flex">
                                    <v-icon color="green"> mdi-check </v-icon>
                                    <span class="ml-3">Datos estadisticos de los suministradores surgidos en la aplicación</span>
                                </div>
                                <div class="my-4 d-flex">
                                    <v-icon color="green"> mdi-check </v-icon>
                                    <span class="ml-3">Envío de solicitud al suministrador</span>
                                </div>
                                <v-btn color="green"
                                       raised
                                       dark
                                       @click="dialog.payment = true"
                                       class="pa-6">ir al carro</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>

                </template>
               <template v-else>
                   <v-card-title class="headline mx-auto pt-0 justify-center">
                       <h2 class="font-weight-medium text-center font-family-1 font-size-30">Selecciona tus Servicio Neocity</h2>

                   </v-card-title>
                   <v-card-text>
                       <v-row>
                           <v-col cols="8">
                               <h4>Tu selección de servicios</h4>
                               <v-card
                                       class="mx-auto my-3 shadow-1 rounded-lg seleccionServicios"
                               >
                                   <v-list-item three-line>
                                       <v-list-item-avatar
                                               tile
                                               size="120"
                                               color=""
                                               class="border-1"
                                       >
                                           <v-col>
                                               <h5 class="grey--text">Hasta</h5>
                                               <h1>1MW</h1>
                                               <h5 class="blue--text">Hasta</h5>
                                           </v-col>
                                       </v-list-item-avatar>
                                        <v-col cols="8">
                                            <h4 class="mb-1">Plan de consumo de energía</h4>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                               Integer suscipit commodo sem,Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                       </v-col>
                                       <v-list-item-content class="text-center">
                                           <a href="#">Editar</a>
                                       </v-list-item-content>
                                        <v-icon>mdi-close</v-icon>
                                   </v-list-item>
                               </v-card>
                               <v-card
                                       class="mx-auto my-3 shadow-1 rounded-lg seleccionServicios"
                               >
                                   <v-list-item three-line>
                                       <v-list-item-avatar
                                               tile
                                               size="120"
                                               color=""
                                               class="border-1"
                                       >
                                           <v-col>
                                               <h1 class="blue--text">25%</h1>
                                               <h5 class="blue--text">descuento</h5>
                                               <h5 class="red--text">por pago adelantado</h5>

                                           </v-col>
                                       </v-list-item-avatar>
                                       <v-col cols="8">
                                            <h4 class="mb-1">Pago de envío de solicitudes</h4>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                               Integer suscipit commodo sem,Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                       </v-col>
                                       <v-list-item-content class="text-center">
                                           <a href="#">Editar</a>
                                       </v-list-item-content>
                                        <v-icon>mdi-close</v-icon>
                                   </v-list-item>
                               </v-card>
                               <h4 class="my-4 mt-8">Selecciona tu medio de pago</h4>
                               <v-row>
                                   <v-col v-for="tc in 13" cols="2" class="ma-0 pa-1">
                                        <v-card outlined class="pa-1" height="57">
                                            <div
                                                    class="py-3 text-center grey lighten-2 rounded-0"
                                                    v-text="`tarjeta`"
                                            ></div>
                                       </v-card>  
                                   </v-col>
                               </v-row>
                               <h4 class="my-4">Paga con tarjetas de casas comerciales</h4>
                               <v-row>
                                   <v-col v-for="tcc in 6" cols="2" class="ma-0 pa-1" >
                                      <v-card outlined class="pa-1" height="57">
                                        <div
                                            class="text-center py-3 grey lighten-2 rounded-0"
                                            v-text="`tarjeta`"
                                        ></div>
                                      </v-card>  
                                       
                                   </v-col>
                               </v-row>
                           </v-col>
                           <v-col cols="4">
                               <h4 class="mb-4">Detalles de la compra</h4>

                               <v-card style="border: 3px solid #2196F3" class="rounded-lg detalleCompra">
                                   <v-card-title>
                                       <v-row class="px-2">
                                           <v-col cols="9">
                                               <h3>
                                                   Plan Cortesia
                                               </h3>
                                               <p>1 MW Energía</p>
                                           </v-col>
                                           <v-col cols="3">
                                               <h2 class="blue--text text-right">
                                                   5UF
                                               </h2>
                                           </v-col>
                                       </v-row>
                                       <v-col cols="12">
                                            <v-divider></v-divider>
                                       </v-col>
                                       <v-row class="px-2">
                                           <v-col cols="9">
                                               <h3>
                                                   Pago de envío de solicitudes
                                               </h3>
                                               <p>pago anticipado con descuento</p>
                                           </v-col>
                                           <v-col cols="3">
                                               <h2 class="blue--text text-right">
                                                   5UF
                                               </h2>
                                           </v-col>
                                       </v-row>
                                   </v-card-title>
                                   <v-divider class="py-10"></v-divider>
                                   <v-card-text>
                                       <br>
                                   </v-card-text>
                                   <v-divider></v-divider>
                                   <v-card-actions>
                                       <v-row class="px-2">
                                           <v-col cols="9">
                                               <h3>
                                                   Total a Pagar
                                               </h3>
                                           </v-col>
                                           <v-col cols="3">
                                               <h2 class="blue--text text-right">
                                                   10UF
                                               </h2>
                                           </v-col>
                                       </v-row>

                                   </v-card-actions>
                               </v-card>
                               <v-checkbox >
                               <template v-slot:label>
                                    <a class="font-size-13"s href="#">He leido y acepto los terminos y condiciones</a>
                               </template>
                               </v-checkbox>
                               <v-btn color="green"
                                      raised
                                      dark
                                      @click="dialog.payment = false; dialog.updatePlan = false"
                                      class="pa-6 px-12">Pagar</v-btn>
                           </v-col>
                       </v-row>
                   </v-card-text>
               </template>
            </v-card>
        </v-dialog>
        <document-loaded-component
            ref="documentLoaded"
        ></document-loaded-component>
    </v-col>
</template>
<script>
  import DocumentLoadedComponent from '@/components/system/DocumentLoadedComponent.vue';
    export default {
        name: 'DashboardConsumer',
         components: {
            DocumentLoadedComponent
        },
        data() {
            return {
                dialog:{
                    createCompany:false,
                    withdrawalPoint:false,
                    updatePlan:false,
                    payment:false
                }
            }
        },
        created: function () {
            this.$emit('SetcolorMenu', '#FE9A00');
        }
    }
</script>